/* @sravni/react-header version 0.2.43 */
var defaultMobileNavigation = [
    {
        "text": "Кредиты",
        "href": "/kredity/onlajn-zayavka-na-kredit/",
        "customStyle": "",
        "isLink": true,
        "nofollow": false,
        "noindex": false,
        "openInNew": false,
        "icon": null,
        "iconSrc": null,
        "isTextVisible": true,
        "children": [
            {
                "text": "Группа 1",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Подбор кредита",
                        "href": "/kredity/onlajn-zayavka-na-kredit/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Wallet.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Кредитный рейтинг",
                        "href": "/kredity/scoring/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Scoring.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Потребительские кредиты",
                        "href": "/kredity/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Orders.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Рефинансирование",
                        "href": "/kredity/promo/refinansirovanie/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Exchange.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Автокредиты",
                        "href": "/avtokredity/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Car.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Кредиты для бизнеса",
                        "href": "/biznes-kredity/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Briefcase.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Банкротство",
                        "href": "/bankrotstvo/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/ChartDown.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 2",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "",
                        "href": "",
                        "customStyle": "border-bottom: 1px solid #E6EAEF;height: 1px;margin: 16px 0 8px;",
                        "isLink": false,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": false,
                        "children": []
                    },
                    {
                        "text": "Курсы обмена валют",
                        "href": "/valjuty/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Рейтинг банков",
                        "href": "/banki/rating/klientskij/?productCategory=natural",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Список банков",
                        "href": "/banki/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Отзывы о банках",
                        "href": "/banki/otzyvy/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            }
        ]
    },
    {
        "text": "Страхование",
        "href": "",
        "customStyle": "",
        "isLink": false,
        "nofollow": false,
        "noindex": false,
        "openInNew": false,
        "icon": null,
        "iconSrc": null,
        "isTextVisible": true,
        "children": [
            {
                "text": "Группа 1",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "ОСАГО",
                        "href": "/osago/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Car.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Каско",
                        "href": "/kasko/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Car.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Страхование ипотеки",
                        "href": "/strahovanie-ipoteki/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/HouseSafety.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Страхование путешественников",
                        "href": "/vzr/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Plane.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Страхование квартиры",
                        "href": "/strahovanie-nedvizhimosti/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/ShieldSafety.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 2",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Страхование спортсменов",
                        "href": "/strahovanie-ns/sportivnaya/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/PrizeCup.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Добровольное медицинское страхование",
                        "href": "/dms/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Stethoscope.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "От критических заболеваний",
                        "href": "/strahovka-kriticheskie-bolezni/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Lungs.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Страхование от укуса клеща",
                        "href": "/strahovka-ot-klescha/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Bug.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Страхование дома и дачи",
                        "href": "/strahovanie-domov/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/InsuranceHouse.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 3",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "",
                        "href": "",
                        "customStyle": "border-bottom: 1px solid #E6EAEF;height: 1px;margin: 16px 0 8px;",
                        "isLink": false,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": false,
                        "children": []
                    },
                    {
                        "text": "Проверка КБМ",
                        "href": "/osago/proverka-kbm/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Рейтинг страховых компаний",
                        "href": "/strakhovye-kompanii/rating/klientskij/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Список страховых компаний",
                        "href": "/strakhovye-kompanii/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Отзывы о страховых компаниях",
                        "href": "/strakhovye-kompanii/otzyvy/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Статьи о страховании",
                        "href": "/novosti/rubrika/strahovki/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            }
        ]
    },
    {
        "text": "Займы",
        "href": "",
        "customStyle": "",
        "isLink": false,
        "nofollow": false,
        "noindex": false,
        "openInNew": false,
        "icon": null,
        "iconSrc": null,
        "isTextVisible": true,
        "children": [
            {
                "text": "Группа 1",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Займы онлайн",
                        "href": "/zaimy/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/PhoneDownload.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Займы на карту",
                        "href": "/zaimy/na-kartu/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CreditCard.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Займы без отказа",
                        "href": "/zaimy/na-kartu-bez-otkazov/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/ThumbUp.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Займы с плохой КИ",
                        "href": "/zaimy/s-plokhoj-kreditnoj-istoriej/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/ChartDown.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Займы без процентов",
                        "href": "/zaimy/bez-protsentov/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Percent.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Банкротство",
                        "href": "/bankrotstvo/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/ChartDown.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 2",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Лучшие займы",
                        "href": "/zaimy/top/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Fire.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Займы под залог ПТС",
                        "href": "/zaimy/pod-pts/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Car.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Займы через Госуслуги",
                        "href": "/zaimy/cherez-gosuslugi/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Fingerprint.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Займы до зарплаты",
                        "href": "/zaimy/na-kartu-do-zarplaty/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/MyCredits.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Долгосрочные займы",
                        "href": "/zaimy/dolgosrochnye/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CalendarSimple.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 3",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Рейтинг МФО",
                        "href": "/zaimy/rating-mfo/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Список МФО",
                        "href": "/zaimy/mfo/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Отзывы об МФО",
                        "href": "/zaimy/otzyvy/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            }
        ]
    },
    {
        "text": "Ипотека",
        "href": "",
        "customStyle": "",
        "isLink": false,
        "nofollow": false,
        "noindex": false,
        "openInNew": false,
        "icon": null,
        "iconSrc": null,
        "isTextVisible": true,
        "children": [
            {
                "text": "Группа 1",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Ипотечные кредиты",
                        "href": "/ipoteka/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/House.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Вторичное жилье",
                        "href": "/ipoteka/zhile-na-vtorichnom-rynke/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/HouseVacations.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Новостройки",
                        "href": "/ipoteka/zhile-na-pervichnom-rynke/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/House.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 2",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Строительство дома",
                        "href": "/ipoteka/na-stroitelstvo-doma/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/HouseSafety.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Рефинансирование ипотеки",
                        "href": "/ipoteka/refinansirovanie-ipoteki/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Exchange.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Ипотека в новостройках ПИК",
                        "href": "/special/pik/?promo=1",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "//f.sravni.ru/logotypes/menu/pikLogo.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 3",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Рейтинг банков",
                        "href": "/banki/rating/klientskij/?productCategory=natural",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Список банков",
                        "href": "/banki/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Отзывы о банках",
                        "href": "/banki/otzyvy/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            }
        ]
    },
    {
        "text": "Карты",
        "href": "/kredity/promo/karty/",
        "customStyle": "",
        "isLink": true,
        "nofollow": false,
        "noindex": false,
        "openInNew": false,
        "icon": null,
        "iconSrc": null,
        "isTextVisible": true,
        "children": [
            {
                "text": "Группа 1",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Подбор кредитной карты",
                        "href": "/kredity/promo/karty/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CreditCardGroupo.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Кредитные карты",
                        "href": "/karty/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CardTimer.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Дебетовые карты",
                        "href": "/debetovye-karty/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CardPlus.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 2",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Рейтинг банков",
                        "href": "/banki/rating/klientskij/?productCategory=natural",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Список банков",
                        "href": "/banki/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Отзывы о банках",
                        "href": "/banki/otzyvy/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            }
        ]
    },
    {
        "text": "Вклады",
        "href": "",
        "customStyle": "",
        "isLink": false,
        "nofollow": false,
        "noindex": false,
        "openInNew": false,
        "icon": null,
        "iconSrc": null,
        "isTextVisible": true,
        "children": [
            {
                "text": "Группа 1",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Вклады",
                        "href": "/vklady/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Deposit.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Накопительные счета",
                        "href": "/vklady/nakopitelnye/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Percent.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Валютные вклады",
                        "href": "/vklady/valjutnie/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/DollarSign.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Вклады для пенсионеров",
                        "href": "/vklady/pensionnye/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Users.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Вклады с пополнением",
                        "href": "/vklady/s-popolneniem/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CoinsPlus.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 2",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Куда вложить деньги",
                        "href": "/promo/bonus/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Star.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Брокерское обслуживание",
                        "href": "/invest/brokerskoe-obsluzhivanie/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Briefcase.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Инвестиции в МФО",
                        "href": "/invest/investicii-v-mfo/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CoinStack.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 3",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Рейтинг банков",
                        "href": "/banki/rating/klientskij/?productCategory=natural",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Список банков",
                        "href": "/banki/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Отзывы о банках",
                        "href": "/banki/otzyvy/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            }
        ]
    },
    {
        "text": "Для бизнеса",
        "href": "",
        "customStyle": "",
        "isLink": false,
        "nofollow": false,
        "noindex": false,
        "openInNew": false,
        "icon": null,
        "iconSrc": null,
        "isTextVisible": true,
        "children": [
            {
                "text": "Группа 1",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Сервис регистрации самозанятых",
                        "href": "/biznes-oformlenie-samozanyatogo/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/IdentityCard.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Расчетно-кассовое обслуживание",
                        "href": "/rko/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CardTerminal.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Кредиты",
                        "href": "/biznes-kredity/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Briefcase.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Банковские гарантии",
                        "href": "/biznes/bankovskie-garantii/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "//f.sravni.ru/logotypes/menu/bankGuarantees.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Эквайринг",
                        "href": "/biznes/ekvajring/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Acquiring.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Вклады",
                        "href": "/biznes-vklady/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CoinRub.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Регистрация бизнеса",
                        "href": "/biznes-registration/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/BlankStamp.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Бухгалтерские услуги",
                        "href": "/biznes-accounting/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/BusinessAccounting.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Бизнес на маркетплейс",
                        "href": "/biznes-marketplace",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Management.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Лизинг",
                        "href": "/biznes-leasing/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/ProductsSearch.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Внесение изменений в ИП и ООО",
                        "href": "/biznes-vnesenie-izmeneniy/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CursorSelected.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Ликвидация ИП",
                        "href": "/biznes-likvidaciya/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/FileCrossOut.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 2",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "",
                        "href": "",
                        "customStyle": "border-bottom: 1px solid #E6EAEF;height: 1px;margin: 16px 0 8px;",
                        "isLink": false,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": false,
                        "children": []
                    },
                    {
                        "text": "Рейтинг банков для бизнеса",
                        "href": "/banki/rating/klientskij/?productCategory=legal",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Отзывы о банках",
                        "href": "/banki/otzyvy/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Статьи о бизнесе",
                        "href": "/novosti/teg/biznes/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            }
        ]
    },
    {
        "text": "Образование",
        "href": "/kursy/",
        "customStyle": "",
        "isLink": true,
        "nofollow": false,
        "noindex": false,
        "openInNew": false,
        "icon": null,
        "iconSrc": null,
        "isTextVisible": false,
        "children": [
            {
                "text": "Группа 1",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Программирование",
                        "href": "/kursy/programmirovanie/",
                        "customStyle": "",
                        "isLink": false,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Programming.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Аналитика",
                        "href": " /kursy/professii-analitik/",
                        "customStyle": "",
                        "isLink": false,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Analytics.svg",
                        "isTextVisible": false,
                        "children": []
                    },
                    {
                        "text": "Маркетинг",
                        "href": "/kursy/professii-marketolog/",
                        "customStyle": "",
                        "isLink": false,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Marketing.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Управление",
                        "href": "/kursy/upravlencheskie/",
                        "customStyle": "",
                        "isLink": false,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Briefcase.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Английский язык",
                        "href": "/kursy/anglijskij-yazyk/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Bubble.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Дизайн",
                        "href": "/kursy/dizajn/",
                        "customStyle": "",
                        "isLink": false,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Design.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Веб-дизайн",
                        "href": "/kursy/dizajn-web/",
                        "customStyle": "",
                        "isLink": false,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/WebDesign.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Графический дизайн",
                        "href": " /kursy/dizajn-graficheskij/",
                        "customStyle": "",
                        "isLink": false,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/GraphicDesign.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "QA (тестирование)",
                        "href": "/kursy/programmirovanie-testirovshchik/",
                        "customStyle": "",
                        "isLink": false,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/QA.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "1С",
                        "href": "/kursy/programmirovanie-1s/",
                        "customStyle": "",
                        "isLink": false,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Programming1C.svg",
                        "isTextVisible": false,
                        "children": []
                    },
                    {
                        "text": "Python",
                        "href": "/kursy/programmirovanie-python/",
                        "customStyle": "",
                        "isLink": false,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Globe.svg",
                        "isTextVisible": false,
                        "children": []
                    },
                    {
                        "text": "Подготовка к ЕГЭ и ОГЭ",
                        "href": "/ege-oge/",
                        "customStyle": "",
                        "isLink": false,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/BookOpen.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 2",
                "href": "",
                "customStyle": "border-bottom: 1px solid #E6EAEF;height: 1px;margin: 16px 0 8px;",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "",
                        "href": "",
                        "customStyle": "border-bottom: 1px solid #E6EAEF;height: 1px;margin: 16px 0 8px;",
                        "isLink": false,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": false,
                        "children": []
                    },
                    {
                        "text": "Рейтинг курсов",
                        "href": "/kursy/rating/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": false,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Отзывы о курсах",
                        "href": "/kursy/otzyvy/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Статьи о курсах",
                        "href": "/novosti/teg/obrazovanie/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": false,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            }
        ]
    },
    {
        "text": "Журнал",
        "href": "",
        "customStyle": "",
        "isLink": false,
        "nofollow": false,
        "noindex": false,
        "openInNew": false,
        "icon": null,
        "iconSrc": null,
        "isTextVisible": true,
        "children": [
            {
                "text": "Группа 1",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Главное",
                        "href": "/novosti/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Calculations.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Спецпроекты",
                        "href": "/promo/special-projects/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Rocket.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Тесты и игры",
                        "href": "/novosti/teg/testy-i-igry/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Gamepad.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Вопросы и ответы",
                        "href": "/q/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/QnA.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Блоги компаний",
                        "href": "/novosti/rubrika/novosti-partnerov/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Subscriptions.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Рейтинг экспертов",
                        "href": "/u/rating/",
                        "customStyle": "",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/PrizeCup.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 2",
                "href": "",
                "customStyle": "",
                "isLink": false,
                "nofollow": false,
                "noindex": false,
                "openInNew": false,
                "icon": null,
                "iconSrc": null,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "",
                        "href": "",
                        "customStyle": "border-bottom: 1px solid #E6EAEF;height: 1px;margin: 16px 0 8px;",
                        "isLink": false,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": false,
                        "children": []
                    },
                    {
                        "text": "Карты",
                        "href": "/novosti/rubrika/karty/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Вклады",
                        "href": "/novosti/rubrika/vklady/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Кредиты",
                        "href": "/novosti/rubrika/kredity/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Инвестиции",
                        "href": "/novosti/rubrika/investicii/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Недвижимость",
                        "href": "/novosti/rubrika/nedvizhimost/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Страхование",
                        "href": "/novosti/rubrika/strahovki/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Советы",
                        "href": "/novosti/rubrika/sovety/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": null,
                        "iconSrc": null,
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            }
        ]
    }
];

export { defaultMobileNavigation };
//# sourceMappingURL=defaultMobileNavigation.js.map
